/* eslint-disable no-magic-numbers */
import { Component, OnInit } from '@angular/core';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { AppConstants } from 'src/app/core/constants';

@Component({
  selector: 'app-customer-testimonial',
  templateUrl: './customer-testimonial.component.html',
  styleUrls: ['./customer-testimonial.component.scss',],
})
export class CustomerTestimonialComponent implements OnInit {

  customerTestimonial = [
    {
      story: 'Earlier I got a quote of 26k for Wagnor but thanks to pumpumpum I got Polo at 15k and the quality and services are unmatchable',
      name: 'Sianna Sichen Liu',
      designation: 'Director, Bulbul - Online video shopping App',
      avatar: 'Sichen-Sianna-Liu.jpeg',
    },
    {
      story: 'Buying a car is a big hassle, the concept created by pumpumpum is phenomenal I am a proud customer who uses my daily commute through their cars. Highly recommended who are looking to buy pre-owned cars, try pumpumpum and feel free from all tension of owning a car',
      name: 'Shrawan',
      designation: 'Director, Bron India Pvt Ltd',
      avatar: 'shravan-kumar.jpeg',
    },
    {
      story: 'Being a startup founder, I can totally say their services are unbeatable. Earlier I was supposed to take car from other rental companies but I chose pumpumpum. They\'re cheaper and best in quality',
      name: 'Arpit',
      designation: 'CTO, Chakr Innovation',
      avatar: 'arpit-dhupar.jpeg',
    },
  ];

  faAngleRight = faAngleLeft;
  faAngleLeft = faAngleRight;

  currentSlide: number = AppConstants.ZERO;

  ngOnInit(): void {
    this.nextSlide(this.currentSlide);
  }

  nextSlide(x: number) {
    this.currentSlide = (this.currentSlide + this.customerTestimonial.length + x) % this.customerTestimonial.length;
  }

  slideTo(slideNum: number) {
    this.currentSlide = slideNum;
  }
}
